export default __webpack_public_path__ + "static/media/forest.628e2ac1.jpg";